document.querySelectorAll('.bloc-menu').forEach((bloc) => {
    const img = bloc.querySelector('.bloc-menu__image img');
    const sections = [...bloc.querySelectorAll('.section[data-image]')];

    if (!img || !sections.length) return;

    img.src = sections[0].dataset.image;
    let current = sections[0];

    window.addEventListener('scroll', () => {
        let active = sections[0];
        for (const section of sections) {
            if (section.getBoundingClientRect().top <= window.innerHeight / 2) {
                active = section;
            }
        }
        if (active !== current) {
            current = active;
            img.classList.add('is-fading');
            setTimeout(() => {
                img.src = active.dataset.image;
                img.classList.remove('is-fading');
            }, 150);
        }
    }, { passive: true });
});
